import faqTemplate from '../constants/faq_template'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    ticker: {
      type: [String, Number],
      required: true,
    },
    stockName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      expandIndex: -1,
      explainAreaHeight: [],
      headerAreaHeight: [],
    }
  },

  mounted() {
    this.headerAreaHeight = this.getHeightFromClassName('.faq-list-item-header')
  },

  watch: {
    isLoading(newValue) {
      if (newValue) {
        return
      }

      // 取得 height 必須在 browser render 後，在這邊使用 nextTick() 會在 render 前執行，
      // 故在此處必須使用 setTimeout()
      setTimeout(() => {
        this.headerAreaHeight = this.getHeightFromClassName('.faq-list-item-header')
      }, 0)
    },
  },

  computed: {
    faqList() {
      return faqTemplate.map((item) => ({
        title: this.replaceFAQTemplateString(item.title),
        explain: this.replaceFAQTemplateString(item.explain),
      }))
    },
  },

  methods: {
    replaceFAQTemplateString(content) {
      // displayStockName 將公司名稱最後一個字為英文字母或 . 的後面增加空白
      const displayStockName = this.stockName.replace(/([a-zA-Z]|\.)$/, '$1 ')
      return content.replace(/({ticker})/ig, this.ticker)
        .replace(/({name})/ig, displayStockName)
    },
    expandAnswer(index) {
      if (this.isLoading) {
        return
      }
      this.explainAreaHeight = this.getHeightFromClassName('.faq-list-item-explain')
      this.expandIndex = (this.expandIndex === index) ? -1 : index
    },
    dynamicListItemHeight(index) {
      const headerHeigh = this.headerAreaHeight[index]
      const explainHeight = this.explainAreaHeight[index]
      const height = this.expandIndex === index
        ? explainHeight + headerHeigh + 10 : headerHeigh
      return { height: `${height}px` }
    },
    getHeightFromClassName(className) {
      const domSelector = document.querySelectorAll(className)
      return Array.from(domSelector)
        .map((item) => (item.offsetHeight))
    },
  },
}
